import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { ApplicationState } from '../redux/States';
import { ErrorDispatches } from '../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { LoadingPage } from './Loading';
import { useClassGrade, useClassStudents } from '../hook';
import createDecorator from 'final-form-calculate';
import apis from '../apis';
import {
  InjuryMomentEnum,
  InjuryPlaceEnum,
  StudentHealthInfo,
  StudentInjury,
  StudentInjuryWithPid,
  StudentName,
  ClassSetting
} from '../model';
import { DateTime } from 'luxon';
import {
  AuthedLayout,
  CheckBoxField,
  DATETIME_FORMAT_WITH_TIME,
  DateTimeField,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
  InputDropdownGroupField,
  MyInputGroup,
  OverflowWithTooltip,
  TextField,
} from '../components';
import {
  Button,
  Col,
  FormCheck,
  FormControl,
  Modal,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap';
import { DEFAULT_DATETIME_FORMAT } from '../utils/date';
import { Field, Form, useForm } from 'react-final-form';
import { I18N } from '../i18n-raw';
import { toast } from 'react-toastify';
import { serializeInjury, downloadNameListSheets, downloadSheets } from '../utils';
import { createForm, FormApi } from 'final-form';
import XLSX from 'xlsx-js-style';

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatch = ErrorDispatches;
const bodyMindBookNDegree: { [key: string]: string } = {
  1: '輕度',
  2: '中度',
  3: '極重度',
};
const decorators = [
  createDecorator<StudentInjury>({
    field: 'date',
    updates: {
      momentEnum: (value, allValues) => {
        if (value instanceof DateTime) {
          const hour = value.hour;
          let momentEnumValue = InjuryMomentEnum.Morning;
          if (hour >= 5 && hour < 12) {
            momentEnumValue = InjuryMomentEnum.Morning;
          } else if (hour === 12) {
            momentEnumValue = InjuryMomentEnum.Noon;
          } else if (hour > 12 && hour < 18) {
            momentEnumValue = InjuryMomentEnum.Afternoon;
          }
          return momentEnumValue;
        }
        return value;
      },
    },
  }),
];
const schoolList: string[] = ['010301', '011501', '011607', '020301', '020302', '020308', '020403', '020404', '020405', '020407', '020409', '020C03', '020C04', '020C05', '020C07', '020C09', '020F012', '030305', '030403', '030C02', '030c03', '030C07', '030C08', '030G92', '040302', '040304', '040308', '040B02', '0413032', '041303', '041305', '041305', '0413062', '041306', '0413072', '041307', '041401', '041602', '041601', '041602', '041B03', '041B05', '041B06', '041B07', '041C01', '050303', '050310', '050314', '050315', '050401', '050404', '050407', '050B14', '050C07', '050f01', '0513022', '051302', '0513062', '051306', '051307', '051307', '051408', '051413', '051B02', '051B05', '051B06', '051C08', '051C11', '060322', '060323', '063C02', '060c07', '060C08', '060C20', '070301', '070304', '070307', '070316', '070319', '070401', '070402', '070403', '070405', '070406', '070408', '070409', '070410', '070415', '070B16', '070C01', '070C02', '070c03', '070C05', '070C06', '070C08', '070C09', '070c10', '070C15', '070F011', '070F012', '070F021', '070F021', '071311', '071311', '071317', '071318', '071414', '071B18', '071C14', '080302', '080305', '080307', '080308', '080401', '080403', '080404', '080406', '080410', '080B05', '080B07', '080B08', '080c04', '080C06', '080C10', '081311', '081312', '081312', '0813131', '081313', '081313', '0813142', '081314', '081409', '081C09', '090305', '090306', '090315', '090401', '090402', '090403', '090404', '090413', '090C42', '090C03', '090C13', '090F012', '090F012', '091307', '091307', '0913082', '091308', '091311', '091312', '091316', '091318', '091319', '0913202', '091410', '091414', '091B18', '091C10', '091C14', '100301', '100302', '100402', '100B01', '101304', '101406', '101C05', '101C07', '110302', '110308', '110311', '110312', '110314', '110315', '110317', '1103281', '110328', '110401', '110403', '110404', '110405', '110406', '110407', '110409', '110410', '110B02', '110B08', '110B12', '110C01', '110C03', '110C04', '110C05', '110C06', '110C09', '110F011', '110F01', '111313', '111313', '111320', '111321', '111321', '111322', '111322', '111323', '111326', '111419', '111427', '111502', '111B20', '111B25', '111B26', '111C16', '111C19', '111C27', '111G91', '120303', '120304', '120311', '120319', '120401', '120402', '120409', '120C02', '120C09', '121306', '1213072', '121307', '1213182', '121318', '1213202', '1213202', '121320', '121405', '121413', '121415', '121417', '121B06', '121C05', '121C10', '121C13', '121C15', '121C17', '130302', '130305', '130306', '130322', '130401', '130403', '130404', '130410', '130417', '130601', '130C03', '130C04', '130C17', '131307', '1313082', '131308', '131311', '131311', '131409', '131501', '131B07', '131C09', '131C18', '1402223', '1403012', '140301', '140302', '140303', '140404', '140405', '140408', '140601', '140C01', '140C05', '140C08', '1413072', '141307', '141406', '150302', '150303', '150309', '150401', '150404', '150405', '150411', '150601', '150B09', '150c04', '150C05', '150C11', '150F012', '150F012', '1513062', '151306', '151307', '151312', '151312', '151410', '151602', '151C10', '160302', '160401', '170301', '170302', '170403', '170404', '170B01', '170C03', '170C04', '170F011', '170F01', '1713062', '171306', '1713082', '171308', '171405', '171407', '171B08', '1803012', '1803012', '180301', '180302', '180309', '180403', '180404', '180601', '180C03', '180c04', '181305', '1813062', '181306', '1813072', '181307', '181308', '181601', '181B05', '181B07', '181B08', '190406', '190601', '190C06', '191603', '200302', '200303', '200401', '200405', '200406', '200407', '200601', '200B03', '200C05', '200c06', '200C07', '200F012', '200F012', '201304', '201304', '201310', '201310', '2013122', '201312', '2013132', '201313', '201314', '201408', '201B09', '201C08', '210303', '210305', '210306', '210309', '210408', '210416', '210601', '210B05', '210B09', '210C08', '210F011', '210F012', '211301', '211302', '211304', '2113102', '211310', '211314', '2113152', '211315', '211317', '211318', '211320', '211407', '211412', '211419', '211601', '211602', '211B01', '211B02', '211B14', '211B17', '211C07', '211C12', '211C19', '3303012', '330301', '330601', '380301', '380601', '4001443', '5403012', '540301', '580301', '6104052', '710301', '710401', '720301', '040F011', '040F01', '130F012', '130F01', '140F01', '020F01', '070F01', '070F024', '090F01', '091320', '150F01', '1513121', '200F01', '1913022', '191302', '210F01', '080F012', '080F01', '011399', '110F01', '710C01', '140F011', '140F012', '030B16', '061B17', '080C07', '101B05', '101B08', '101B09', '121B18', '121C08', '121C12', '121C16', '131C14', '151B07', '171C07', '180G91', '181B06', '181C08', '191B08', '201B04', '201B72', '211B13', '211B18', '321B01', '341B02', '361B01', '381B05', '411C01', '421B01', '581B01', '011307', '011607', '024325', '024699', '071318', '141301', '131601', '181502', '181603', '121502', '121502', '0513071', '0603232', '610405', '091319', '171601', '121302', '1913021', '040F011', '130F012', '080F012', '050f01', '0713183', '121405', '1313072', '211603', '100303', '130307', '061323', '111601', '060Q23', '120320', '1203202', '170F011'];
const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;
const ObservationMins = Array.from<number>({ length: 120 }).reduce(
  (obj, _, i) => ({ ...obj, [(i + 1) * 5]: '1' }),
  {} as Record<number, string>
);
const TemperatureNumbers = Array.from<number>({ length: 61 }).reduce(
  (obj, _, i) => ({
    ...obj,
    [(i * 0.1 + 34.0).toFixed(1)]: [i * 0.1 + 34].toString(),
  }),
  {} as Record<number, string>
);
const InjuryHistoriesHeader: HeaderDisplayKeysWithType<StudentInjury>[] = [
  { display: '學年', property: 'year', style: { width: '3rem' } },
  {
    display: '月',
    property: 'date',
    onRender: (v) => {
      return v instanceof DateTime ? v.toFormat('M') : null;
    },
    style: { width: '0.5rem' },
  },
  {
    display: '日期',
    property: 'date',
    onRender: (v) => {
      return v instanceof DateTime ? v.toFormat('yyyy/MM/dd') : null;
    },
    style: { width: '2rem' },
  },
  {
    display: '時段',
    property: 'momentEnum',
    onRender: (v) =>
      typeof v === 'number' ? I18N.InjuryMoment[v as InjuryMomentEnum] : '',
    style: { width: '3rem' },
  },
  {
    display: '時間',
    property: 'date',
    onRender: (v) => {
      return v instanceof DateTime ? v.toFormat('HH:mm') : null;
    },
    style: { width: '2rem' },
  },
  {
    display: '地點',
    property: 'placeEnum',
    onRender: (v) =>
      typeof v === 'number' ? I18N.InjuryPlace[v as InjuryPlaceEnum] : '',
    style: { width: '6rem' },
  },
  {
    display: '情形',
    property: 'memos',
    onRender: (v, i, e, c) => {
      const { allValues } = c;

      return serializeInjury(allValues);
      return (
        <OverflowWithTooltip> {serializeInjury(allValues)}</OverflowWithTooltip>
      );
    },
    style: { textAlign: 'left' },
  },
];

const inheritDiseaseMap1: { [key: number]: string } = {
  1: '糖尿病',
  2: '血友病',
  5: '蠶豆症',
  31: '高血壓',
  99: '其他',
};
const relativeMap1: { [key: number]: string } = {
  1: '父親',
  2: '母親',
  3: '祖父',
  4: '祖母',
  5: '兄',
  6: '弟',
  7: '姐',
  8: '妹',
  13: '外祖父',
  14: '外祖母',
};
const InsuranceMap1: { [key: number]: string } = {
  1: '全民健保',
  2: '學生團保',
  9: '其他',
};
type InjuryAreaProps = {
  area: string;
  show: boolean;
};
type InjuryProps = {
  property: string;
  displayClassName?: string;
};

const injuryPage: FunctionComponent<Props> = ({ user, catchErrorForModal }) => {
  if (!user) return <LoadingPage />;

  type Student = { 
      seat?: number | null;
      name?: string | null;
      year?: number | null; 
      sex?: string | null;
      cSex?: string | null;
      pid?: string | null;
      dad?: string | null;
      mom?: string | null;
      zip?: string | null;
      address?: string | null;
      erTel?: string | null;
      tel?: string | null;
      realAge?: string | null;
      birth?: DateTime | null;
      sid?: string | null;
      gradeNoSeat?: string | null;
      hospital?: string | null;
      [key: string]: any; // Index signature to allow dynamic keys 
    };
  const [memos, setMemos] = useState('');
  const [lastDate, setLastDate] = useState<DateTime>(DateTime.now());
  const [injury, setInjury] = useState<StudentInjury>(GenerateDefaultInjury(lastDate));
  const [healthInfo, setHealthInfo] = useState<StudentHealthInfo>();
  const [insert, setInsert] = useState(true);
  const hideAfterInsertRef = useRef<HTMLInputElement>(null);
  const [hideAfterInsert, setHideAfterInsert] = useState(true);
  const [waitingShow, setWaitingShow] = useState(false);
  const [classSettings, setClassSettings] = useState<ClassSetting[]>([]);
  const { currentSemester, semesters, currentSchool, schools } = user;
  const yearSem = semesters[currentSemester];
  const schoolName = schools[currentSchool]?.name || currentSchool;
  const now = new Date();
  const startTime = new Date('2026-10-28T13:00:00');
  const endTime = new Date('2026-10-28T17:00:00');
  const isTimeInRange = now >= startTime && now <= endTime;
  const { selectedClassGrade, element: classGradeButton } = useClassGrade({
    disableQueryParamStore: true,
    yearSem,
  });
  const { selectedStudent, element: studentButton } = useClassStudents({
    yearSem,
    classId: selectedClassGrade?.id,
  });

  const formRef = useRef<FormApi<StudentInjury>>();
  useEffect(() => {
    refreshStudent();
    reset(injury.date ?? DateTime.now());
  }, [selectedStudent?.id]);

  useEffect(() => {
    apis.getClassSettings(yearSem.year, yearSem.sem)
      .then((data) => {
        setClassSettings(data);
      })
      .catch();
  }, [user]);

  useEffect(() => {
    if (!injury.date) return;

    const hour = injury.date.hour;
    let momentEnumValue = InjuryMomentEnum.None;

    if (hour >= 5 && hour < 12) {
      momentEnumValue = InjuryMomentEnum.Morning;
    } else if (hour === 12) {
      momentEnumValue = InjuryMomentEnum.Noon;
    } else if (hour > 12 && hour < 18) {
      momentEnumValue = InjuryMomentEnum.Afternoon;
    }
    // 僅在需要時才更新，避免無限 loop
    if (injury.momentEnum !== momentEnumValue) {
      setInjury((prev) => ({
        ...prev,
        momentEnum: momentEnumValue,
      }));
    }
  }, [injury.date]);

  function refreshStudent() {
    if (selectedStudent) {
      apis
        .GetHealthInfo(selectedStudent.id)
        .then((s) => {
          // 依日期顯示對應學年
          const injuriesData = s.injuries.map((i) => {
            let countYear = i.year;
            if (i.date) {
              countYear = i.date.year - 1911 + (i.date.month >= 8 ? 0 : -1);
              injury.year = countYear;
            }
            return { ...i, year: countYear };
          });
          setHealthInfo({ ...s, injuries: injuriesData });
        })
        .catch(catchErrorForModal);
    }
  }

  function showInjuryUpdate(injury: StudentInjury) {
    setInjury(injury);
    setMemos(injury.memos || '');
    setInsert(false);
  }

  function deleteInjury(injury: StudentInjury) {
    if (selectedStudent) {
      toast
        .promise(apis.RemoveStudentInjuries(selectedStudent.id, injury.id), {
          pending: '傷病資料刪除中......',
          success: '傷病資料刪除成功！',
          error: '傷病資料刪除失敗！請查看錯誤資訊。',
        })
        .then(() => {
          refreshStudent();
        })
        .catch(catchErrorForModal);
    }
  }

  function insertOrUpdateInjuryToDB(injury: StudentInjury) {
    if (selectedStudent) {
      // 依日期顯示對應學年
      if (injury.date) {
        const countYear =
          injury.date.year - 1911 + (injury.date.month >= 8 ? 0 : -1);
        injury.year = countYear;
      }
      toast
        .promise(
          insert
            ? apis.InsertStudentInjuries(selectedStudent.id, injury)
            : apis.UpdateStudentInjuries(selectedStudent.id, injury),
          {
            pending: '傷病資料更新中......',
            success: '傷病資料更新成功！',
            error: '傷病資料更新失敗！請查看錯誤資訊。',
          }
        )
        .then(() => {
          reset(injury.date ?? DateTime.now());
          if (hideAfterInsert) {
            window.history.replaceState(null, '', window.location.pathname);
            window.location.reload();
          } else {
            refreshStudent();
          }
        })
        .catch(catchErrorForModal);
    }
  }

  function reset(date: DateTime) {
    const next = GenerateDefaultInjury(date);
    setInjury(next);
    formRef.current?.reset(next);
    setInsert(true);
    setMemos('');
  }

  async function handleDownloadAllInjuriesExcel() {
    try {
      const blob = await apis.downloadAllInjuriesExcel(currentSchool);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `${schoolName}-傷病歷史資料.zip`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      // toast.error("下載失敗");
    }
  }

  function downloadExcel() {
    return apis.downloadInjuryExcel(
      schoolName,
      yearSem.year,
      yearSem.sem
    )
      .then((blob) => {
        const objlink = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = objlink;
        a.setAttribute('download', `${schoolName}傷病歷史資料.xls`);

        document.body.appendChild(a);
        a.click();

        a.parentNode?.removeChild(a);
        window.URL.revokeObjectURL(objlink);
      })
      .catch(catchErrorForModal)
      .finally(() => {
        toast.success('傷病歷史資料下載完成');
      });
  }

  async function handleDownloadBoth() {
    setWaitingShow(true);
    try {
      await Promise.allSettled([
        downloadExcel(),
        handleDownloadAllInjuriesExcel()
      ]);
    } catch (error) {
      console.error("下載過程發生錯誤", error);
    } finally {
      setWaitingShow(false);
    }
  }



  

  function calculateAge(birthDate: DateTime): number {
    const birthDateObj = new Date(
      birthDate.year,
      birthDate.month - 1,
      birthDate.day
    );

    const today = new Date();
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--;
    }

    return age;
  }

  const InjuryPlace: FunctionComponent<InjuryAreaProps> = ({
    area,
    show = false,
  }) => {
    const className = ['wid-100'];
    if (!show) className.push('d-none');
    return (
      <Button
        className={className.join(' ')}
        onClick={() => {
          setMemos((memos + I18N.Injury[area]).slice(0, 2000));
        }}
      >
        {I18N.Injury[area]}
      </Button>
    );
  };

  const InjuryColumn: FunctionComponent<InjuryProps> = ({
    property,
    displayClassName = 'wid-80',
  }) => {
    return (
      <MyInputGroup>
        <CheckBoxField
          property={property}
          labelClassName={displayClassName}
          label={I18N.Injury[property]}
        />
      </MyInputGroup>
    );
  };
  // const getBetweenYearAndClass = (s?: string): string => {
  //   if (!s) return '';
  //   const i班 = s.indexOf('班');
  //   if (i班 < 0) return '';
  //   const i年 = s.lastIndexOf('年', i班); // 抓在「班」之前最後一個「年」
  //   if (i年 < 0) return '';
  //   return s.slice(i年 + 1, i班).trim();
  // };
  const getBetweenYearAndClass = (s?: string): string => {
    if (!s) return '';
    const m = s.match(/(\d+)班/);
    return m ? m[1] : '';
  };


  const injuryContent = (
    <>
      <Row>
        <div className="wid-130 mr-2">{classGradeButton}</div>
        <div className="mr-2">{studentButton}</div>
      </Row>
      {selectedStudent ? 
      <Row className="align-items-start justify-content-around">
        <Col sm={2} className="mr-2">
          <Table bordered className="student-phi mb-2">
            <colgroup>
              <col width={'30%'} />
              <col width={'70%'} />
            </colgroup>
            <thead>
              <tr>
                <th colSpan={2}>基本資料</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>統編</td>
                <td>{selectedStudent.pid}</td>
              </tr>
              <tr>
                <td>座號</td>
                <td>
                  {selectedClassGrade?.name}{selectedStudent.seat}號
                </td>
              </tr>
              <tr>
                <td>學生</td>
                <td>{selectedStudent.name}</td>
              </tr>
              <tr>
                <td>生日</td>
                <td>
                  {selectedStudent.birth.toFormat(DEFAULT_DATETIME_FORMAT)}
                </td>
              </tr>
              <tr>
                <td>父親</td>
                <td>{selectedStudent.dad}</td>
              </tr>
              <tr>
                <td>母親</td>
                <td>{selectedStudent.mom}</td>
              </tr>
              <tr>
                <td>緊急連絡</td>
                <td>{selectedStudent.erTel}</td>
              </tr>
            </tbody>
          </Table>
          <Table bordered className="student-phi mb-2">
            <colgroup>
              <col width={'30%'} />
              <col width={'70%'} />
            </colgroup>
            <thead>
              <tr>
                <th colSpan={2}>健康基本資料</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>個人疾病史</td>
                {healthInfo?.disease.length ? (
                  <td
                    style={{
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {healthInfo.disease.map(
                      (d, i) =>
                        `${i + 1}.${d.diseaseName}(${d.description})${d.treatment
                        }\n`
                    )}
                  </td>
                ) : (
                  <td>無資料</td>
                )}
              </tr>
              <tr>
                <td>重大傷病卡</td>
                {healthInfo?.seriousDisease.length ? (
                  <td
                    style={{
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {healthInfo?.seriousDisease.map(
                      (d, i) => `${i + 1}.${d.diseaseName}\n`
                    )}
                  </td>
                ) : (
                  <td>無資料</td>
                )}
              </tr>
              {/* <tr>
                <td>身心障礙手冊</td>
                <td>???</td>
              </tr> */}
              <tr>
                <td>身心障礙手冊新制</td>
                {healthInfo?.bodyMindBookN.length ? (
                  <td
                    style={{
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {healthInfo.bodyMindBookN.map(
                      (d, i) =>
                        `${i + 1}.${d.bodyMindName}(${bodyMindBookNDegree[d.degree]
                        })\n`
                    )}
                  </td>
                ) : (
                  <td>無資料</td>
                )}
              </tr>
              <tr>
                <td>家族疾病史</td>
                {healthInfo?.inheritDisease.length ? (
                  <td
                    style={{
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {healthInfo.inheritDisease.map((d, i) => {
                      const inheritDisease =
                        d.inheritDisease === 99
                          ? `其他(${d.states})`
                          : inheritDiseaseMap1[d.inheritDisease];
                      return `${i + 1}.${inheritDisease}_${relativeMap1[d.relative]
                        }\n`;
                    })}
                  </td>
                ) : (
                  <td>無資料</td>
                )}
              </tr>
              <tr>
                <td>護送醫院</td>
                <td>
                  {healthInfo?.hospital.length
                    ? healthInfo.hospital.map((h, i) => `${h.hospitalName}\n`)
                    : '特約醫院'}
                </td>
              </tr>
              <tr>
                <td>保險</td>
                <td>
                  {healthInfo?.insurance.length
                    ? healthInfo.insurance.map((v, i) => {
                      let studentInsurance = ``;
                      if (v.insurance === 9) {
                        studentInsurance = v.states
                          ? `${v.states}\n`
                          : `其他保險\n`;
                      } else {
                        studentInsurance = InsuranceMap1[v.insurance];
                      }
                      return `${studentInsurance}\n`;
                    })
                    : ''}
                </td>
              </tr>
              <tr>
                <td>立體感</td>
                <td>{healthInfo?.sightSolid.length ? '有異狀' : '無異狀'}</td>
              </tr>
            </tbody>
          </Table>
          <Table bordered className="student-phi mb-2">
            <thead>
              <tr>
                <th>在校期間重大傷病事故</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {healthInfo?.seriousInjuries.map((i, idx) => (
                    <p key={idx}>
                      {i.state}({i.date?.toFormat(DEFAULT_DATETIME_FORMAT)})
                    </p>
                  ))}
                </td>
              </tr>
            </tbody>
          </Table>
          <label className="sheet-title">學生備註 :</label>
          <FormControl
            as="textarea"
            readOnly
            value={selectedStudent.remark || ''}
            rows={20}
          />
        </Col>
        <Col sm={9}>
          <Form
            initialValues={injury}
            decorators={decorators}
            onSubmit={(value: StudentInjury, form) => {
              // put memos into value;
              insertOrUpdateInjuryToDB({ ...value, memos });
              const nextDate = value.date ?? DateTime.now();
              setLastDate(nextDate);
              form.reset(GenerateDefaultInjury(nextDate));
            }}
            subscription={{ values: true }}
            render={(prop) => {
              const { handleSubmit, form } = prop;
              const state = form.getState().values;
              formRef.current = form;
              return (
                <>
                  <Row noGutters className="mb-2">
                    <MyInputGroup className="mr-2">
                      <span className="wid-50">日期</span>
                      <DateTimeField
                        showTimeSelect
                        property="date"
                        className="mr-2"
                        format={DATETIME_FORMAT_WITH_TIME}
                      // end={DateTime.now()}
                      />
                      <Button
                        className="rwid-1175"
                        onClick={() => {
                          const now = DateTime.now();
                          form.change('date', now);
                          if (now.hour >= 5 && now.hour < 12) {
                            form.change('momentEnum', InjuryMomentEnum.Morning);
                          } else if (now.hour === 12) {
                            form.change('momentEnum', InjuryMomentEnum.Noon);
                          } else if (now.hour > 12 && now.hour < 18) {
                            form.change(
                              'momentEnum',
                              InjuryMomentEnum.Afternoon
                            );
                          }
                        }}
                      >
                        帶入現在時間
                      </Button>
                    </MyInputGroup>
                    <MyInputGroup className="mr-2">
                      <span>時段:</span>
                      <InputDropdownGroupField
                        groupClassName="wid-60"
                        property="momentEnum"
                        content={I18N.InjuryMoment}
                        selectShow="value"
                        resultShow="value"
                        type="number"
                        needGroup={false}
                      />
                      <span>中午時段為 12：00～12：59</span>
                    </MyInputGroup>
                  </Row>
                  <Row noGutters className="mb-2">
                    <MyInputGroup>
                      <span>休息觀察時間</span>
                      <InputDropdownGroupField
                        className="wid-60"
                        content={ObservationMins}
                        property="observationMins"
                        selectShow="key"
                        resultShow="key"
                        needGroup={false}
                      />
                      <span>分鐘</span>
                    </MyInputGroup>
                    <MyInputGroup>
                      <span>受傷地點</span>
                      <InputDropdownGroupField
                        content={I18N.InjuryPlace}
                        resultClassName="wid-160"
                        property="placeEnum"
                        selectShow="value"
                        resultShow="value"
                        type="number"
                        needGroup={false}
                      />
                      <TextField
                        property="otherPlace"
                        className={
                          state.placeEnum === InjuryPlaceEnum.Other
                            ? ''
                            : 'd-none'
                        }
                      />
                    </MyInputGroup>
                    <MyInputGroup>
                      <span>體溫</span>
                      <InputDropdownGroupField
                        className="wid-60"
                        content={TemperatureNumbers}
                        property="temperature"
                        selectShow="key"
                        resultShow="key"
                        needGroup={false}
                      />
                    </MyInputGroup>
                  </Row>
                  <hr />

                  <Row noGutters>受傷部位</Row>
                  <Row noGutters className="mb-2 rounded-lg border">
                    <InjuryColumn property="head" />
                    <InjuryColumn property="neck" />
                    <InjuryColumn property="shoulder" />
                    <InjuryColumn property="chest" />
                    <InjuryColumn property="belly" />
                    <InjuryColumn property="back" />
                    <InjuryColumn property="eye" />
                    <InjuryColumn property="face" />
                    <InjuryColumn property="mouth" />
                    <InjuryColumn property="nose" />
                    <InjuryColumn property="arm" />
                    <InjuryColumn property="waist" />
                    <InjuryColumn property="leg" />
                    <InjuryColumn property="buttock" />
                    <InjuryColumn property="perineum" />
                  </Row>
                  {state.eye || state.arm || state.leg ? (
                    <>
                      <Row noGutters>加入備註說明</Row>
                      <Row
                        noGutters
                        className="mb-2 p-1 rounded-lg border justify-content-around"
                      >
                        <InjuryPlace area="rightEye" show={state.eye} />
                        <InjuryPlace area="leftEye" show={state.eye} />
                        <InjuryPlace area="rightArm" show={state.arm} />
                        <InjuryPlace area="leftArm" show={state.arm} />
                        <InjuryPlace area="rightLeg" show={state.leg} />
                        <InjuryPlace area="leftLeg" show={state.leg} />
                      </Row>
                    </>
                  ) : (
                    <></>
                  )}
                  <Row noGutters>外傷</Row>
                  <Row noGutters className="mb-2 rounded-lg border">
                    <InjuryColumn property="friction" />
                    <InjuryColumn property="slash" />
                    <InjuryColumn property="press" />
                    <InjuryColumn property="strick" />
                    <InjuryColumn property="twist" />
                    <InjuryColumn property="burn" />
                    <InjuryColumn property="sting" />
                    <InjuryColumn property="fracture" />
                    <InjuryColumn property="old" />
                    <InjuryColumn property="aOther" />
                  </Row>
                  <Row noGutters>內科</Row>
                  <Row noGutters className="mb-2 rounded-lg border">
                    <InjuryColumn property="fever" />
                    <InjuryColumn property="dizzy" />
                    <InjuryColumn property="puke" />
                    <InjuryColumn property="headache" />
                    <InjuryColumn property="toothache" />
                    <InjuryColumn property="stomachache" />
                    <InjuryColumn property="bellyache" />
                    <InjuryColumn property="diarrhoea" />
                    <InjuryColumn property="menses" />
                    <InjuryColumn property="pant" />
                    <InjuryColumn property="noseBlood" />
                    <InjuryColumn property="rash" />
                    <InjuryColumn property="eyeache" />
                    <InjuryColumn property="hOther" />
                  </Row>
                  <Row noGutters>處置作為</Row>
                  <Row noGutters className="mb-2 rounded-lg border">
                    <InjuryColumn property="woundCare" />
                    <InjuryColumn property="ice" />
                    <InjuryColumn property="hot" />
                    <InjuryColumn property="rest" />
                    <InjuryColumn property="noteParent" />
                    <InjuryColumn property="backHome" />
                    <InjuryColumn property="hospital" />
                    <InjuryColumn property="education" />
                    <InjuryColumn property="mOther" />
                  </Row>
                  <Row noGutters className="mb-2">
                    <Col sm={8}>
                      <FormControl
                        type="text"
                        as={'textarea'}
                        placeholder="備註說明(字數上限2000字)"
                        rows={3}
                        value={memos}
                        onChange={(e) => {
                          if (e.target.value.length > 2000) return;
                          setMemos(e.target.value);
                        }}
                      />
                      <div className="text-right">
                        目前字數：{memos.length} / 2000{' '}
                        {memos.length > 2000 ? (
                          <span className="text-danger">超過字數上限</span>
                        ) : null}
                      </div>
                    </Col>
                    <Col>
                      <InjuryColumn
                        property="isSerious"
                        displayClassName="wid-100"
                      />
                      <MyInputGroup>
                        <FormCheck
                          name="hideAfterInsert"
                          ref={hideAfterInsertRef}
                          label="新增後返回至傷病登錄畫面"
                          checked={hideAfterInsert}
                          onChange={(e) =>
                            setHideAfterInsert(
                              hideAfterInsertRef.current?.checked || false
                            )
                          }
                        />
                      </MyInputGroup>
                    </Col>
                  </Row>
                  <Row noGutters className="mb-2">
                    <Button
                      className="mr-2"
                      onClick={() => {
                        handleSubmit();
                      }}
                      disabled={memos.length > 2000}
                    >
                      確定{insert ? '新增' : '修改'}
                    </Button>
                    <Button
                      className="mr-2"
                      onClick={() => {
                        form.reset(GenerateDefaultInjury(lastDate));
                        reset(lastDate);
                      }}
                      variant="secondary"
                    >
                      取消
                    </Button>
                  </Row>
                </>
              );
            }}
          />
          <hr />
          <div className="mt-3 mb-1">顯示歷史資料</div>
          <EditableTableDiv
            values={healthInfo?.injuries || []}
            headers={InjuryHistoriesHeader}
            editable
            onEdit={(v) => showInjuryUpdate(v)}
            deleteable
            onDelete={(v) => deleteInjury(v)}
            onRowRender={(v) => ({
              rowStyle:
                v.id === injury.id ? { backgroundColor: 'lightcoral' } : {},
            })}
          />
        </Col>
      </Row> :
      <></>}
    </>
  );
  const injuryDownloadContent = <>
    <Row>
      <Col sm={12}><h4 className='font-weight-bold'>傷病Excel專區</h4></Col>
      <Col sm={12} className='mb-2'>請點擊按鈕下載。因資料量較大，下載需較長的時間，請您耐心等候，期間請勿操作系統或切換畫面。</Col>
      <Col sm={4}>
        <Button
          className="btn btn-primary"
          onClick={() => {handleDownloadBoth()}}>
          下載傷病資料
        </Button>
      </Col>
    </Row>
    <Modal
      show={waitingShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      centered
    >
    <Modal.Header>
      <Modal.Title id="contained-modal-title-vcenter">
        資料下載中
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>因資料量較大，下載需較長的時間，請您耐心等候，期間請勿操作系統或切換畫面，謝謝配合。</p>
    </Modal.Body>
    </Modal>
  </>;
  const injuryCloseContent = (
    <>
    {/* {['1234562'].includes(currentSchool) ?  */}
    {['044658', '044643', '044684', '044624'].includes(currentSchool) && isTimeInRange ? 
      injuryDownloadContent :
      <p className='font-weight-bold'>115年8月31日（一）起，全面停止傷病登錄與報表功能</p>}
    </>
   );

  return (
    <AuthedLayout>
      {/* 2026/8/17-2026/8/30 schoolList array 裡的學校可以使用傷病登錄，其餘學校只看的到傷病excel專區*/}
      {/* 2026/8/31 schoolList array 裡的學校可以使用傷病登錄，其餘學校只看的到傷病關閉訊息*/}
      {schoolList.includes(currentSchool) ?
        injuryContent : 
        injuryCloseContent
      }
      {/* {injuryContent}
      {schoolList.includes(currentSchool) ?
        <></> : 
        injuryDownloadContent
      } */}
    </AuthedLayout>
  );
};

export const InjuryPage = connector(injuryPage);

function GenerateDefaultInjury(defaultDate: DateTime) {
  return { ...DEFAULT_INJURY, date: defaultDate || DateTime.now() };
}

export const DEFAULT_INJURY: StudentInjury = {
  id: 0,
  yearClassId: 0,
  // date: DateTime.now(),
  year: 0,
  isSerious: false,
  observationMins: 0,
  temperature: 0,
  memos: '',
  place: '',
  otherPlace: '',
  placeEnum: InjuryPlaceEnum.None,
  moment: '',
  momentEnum: InjuryMomentEnum.None,
  head: false,
  eye: false,
  mouth: false,
  face: false,
  nose: false,
  chest: false,
  belly: false,
  back: false,
  shoulder: false,
  arm: false,
  waist: false,
  leg: false,
  neck: false,
  buttock: false,
  perineum: false,
  friction: false,
  slash: false,
  press: false,
  strick: false,
  twist: false,
  burn: false,
  sting: false,
  fracture: false,
  old: false,
  aOther: false,
  fever: false,
  dizzy: false,
  puke: false,
  headache: false,
  toothache: false,
  stomachache: false,
  bellyache: false,
  diarrhoea: false,
  menses: false,
  pant: false,
  noseBlood: false,
  rash: false,
  eyeache: false,
  hOther: false,
  woundCare: false,
  ice: false,
  hot: false,
  rest: false,
  noteParent: false,
  backHome: false,
  hospital: false,
  education: false,
  mOther: false,
};
